import { render, staticRenderFns } from "./Details_info.vue?vue&type=template&id=b1d89c6e&scoped=true"
import script from "./Details_info.vue?vue&type=script&lang=js"
export * from "./Details_info.vue?vue&type=script&lang=js"
import style0 from "./Details_info.vue?vue&type=style&index=0&id=b1d89c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d89c6e",
  null
  
)

export default component.exports